import classNames from 'classnames';
import DatePicker from '../../components/DatePicker/DatePicker';
import Field from '../../components/Field/Field';
import FieldFooter from '../../components/FieldFooter/FieldFooter';
import IDatePickerPayload from '../../types/DatePickerPayload';
import IFieldRender from '../../types/FieldRender';
import { AnyObject } from '../../types/Object';
import { dateFormatValidation } from '../../utilities/validations';
import IDatePickerFormFieldProps from './DatePickerFormFieldProps';

const DatePickerFormField = <FormType extends { [field: string]: any } = AnyObject>({
  form,
  name,
  validations = [{ validation: dateFormatValidation }],
  format,
  onChange,
  error,
  shouldValidateOnUpdate,
  defaultValue = {
    value: null,
    inputValue: '',
  },
  className,
  revalidateOnNewValidations,
  ...other
}: IDatePickerFormFieldProps<FormType>) => {
  const classes = classNames(
    {
      'date-picker-form-field': true,
    },
    className
  );

  function renderDatePicker(fieldProps: IFieldRender<IDatePickerPayload>) {
    const value = form.state.data[name];

    function onDatePickerChanged(datePayload: IDatePickerPayload) {
      fieldProps.handleChange(datePayload, onChange);
    }

    return (
      <>
        <DatePicker
          format={format}
          value={value ? value.value : null}
          error={fieldProps.hasError || error}
          onChange={onDatePickerChanged}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }
  return (
    <Field
      form={form}
      shouldValidateOnUpdate={shouldValidateOnUpdate}
      name={name}
      validations={validations}
      className={classes}
      defaultValue={defaultValue}
      render={renderDatePicker}
      revalidateOnNewValidations={revalidateOnNewValidations}
    />
  );
};

export default DatePickerFormField;
